import Box from '@mui/material/Box';
import { BREADCRUMB_RESOLVERS, BREADCRUMB_ICONS } from '../../constants/breadcrumbs';
import { CrumbConfig } from '../../types/breadcrumbTypes';
import breadcrumbStyles from './breadcrumbStyles';

interface CrumbContentProps {
  config: CrumbConfig;
  params: Record<string, string | undefined>;
  searchParams: URLSearchParams;
}

const CrumbContent = ({ config, params, searchParams }: CrumbContentProps) => {
  const label = config.resolver
    ? (BREADCRUMB_RESOLVERS[config.resolver]?.({ params, searchParams }) ?? config.label ?? '')
    : (config.label ?? '');

  const IconComponent = config.icon
    ? BREADCRUMB_ICONS[config.icon as keyof typeof BREADCRUMB_ICONS]
    : null;

  return (
    <Box sx={breadcrumbStyles.crumbContent}>
      {IconComponent && <IconComponent />}
      {label}
    </Box>
  );
};

export default CrumbContent;
